import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

const SERVER_URL = environment.SERVER_URL;

@Injectable({
  providedIn: 'root',
})
export class TranslationToolsService {
  constructor(private http: HttpClient) {}

  // Fetch all translations
  public getTranslationServices(): Observable<any[]> {
    return this.http.get<any[]>(`${SERVER_URL}/translations/get`); // Corrected endpoint name
  }

  public getTranslationServicesCreateIfNotExisiting(toolName: string): Observable<any[]> {
    return this.http.get<any[]>(`${SERVER_URL}/translations/tool/${toolName}`); // Corrected endpoint name
  }

  async updateTranslation(oldName: string, newName: string): Promise<any> {
    return this.http.put<any>(
      `${SERVER_URL}/translations/update/${oldName}`, 
      { name: newName }
    ).toPromise();
  }
  checkIfTranslationToolExists(toolName: string): Observable<boolean> {
    return this.http.get<boolean>(`${environment.SERVER_URL}/translation-tools/exists?name=${toolName}`);

  }
  addTranslationTool(toolName: string): Observable<any> {
    return this.http.post<any>(`${SERVER_URL}/translation-tools/add`, { name: toolName });
  }

  async deleteTranslation(name: string): Promise<void> {
    return this.http.delete<void>(
      `${SERVER_URL}/translations/delete/${name}`
    ).toPromise();
  }

  public deleteTranslation2(name: string): Observable<void> {
    return this.http.delete<void>(
      `${SERVER_URL}/translations/delete/${name}`
    );
  }


  // Create a new translation
  public createTranslation(name: string): Promise<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    const payload = {
      name, // Only sending 'name' as the payload
    };

    return this.http
      .post(`${SERVER_URL}/translations/create`, payload, httpOptions) // Corrected endpoint name
      .toPromise()
      .then((data: any) => {
        console.log('Finished creating translation');
        return data;
      })
      .catch((error) => {
        console.error('Error creating translation:', error);
        throw error;
      });
  }
}
